'use client'

import type { IconProps } from '@pearlconvert/ui/components/icon/icon.types'

import classNames from 'classnames'

import '@pearlconvert/ui/components/icon/styles/icon.scss'

export default function Icon({
  icon,
  title,
  url,
  size = 'medium',
  className,
}: IconProps) {
  const iconClass = classNames(
    'icon',
    {
      [`icon__${icon}`]: icon,
      [`icon__${size}`]: size,
      icon__link: url,
    },
    className
  )

  return url ? (
    <a href={url} className={iconClass}>
      <span>{title}</span>
    </a>
  ) : (
    <i className={iconClass} aria-hidden="true"></i>
  )
}
